import { DeletePendingUserEndAction } from "../actions/DeletePendingUser";
import { OrgState } from "../state";

export function deletePendingUser(state: OrgState, action: DeletePendingUserEndAction) {
    const { error, organizationId, props } = action.payload;
    const pendingUsers = state.pendingUsers[organizationId] || [];
    const newState: Partial<OrgState> = { error };

    if (!error) {
        const newPendingUsers = pendingUsers.filter(pendingUser => {
            return pendingUser.email !== props.email;
        });

        newState.pendingUsers = { ...state.pendingUsers };
        newState.pendingUsers[organizationId] = newPendingUsers;
    }

    return { ...state, ...newState };
}
